import * as Scrivito from "scrivito";
import PlaceholderOrVimeoComponent from "^/Components/PlaceholderOrVimeoComponent";

function VimeoVideoWidgetComponent(props) {
  const { widget, isOpen, nested } = props;
  return (
    <div>
      {nested && !isOpen ? null : (
        <PlaceholderOrVimeoComponent
          title={widget.get("title")}
          vimeoVideoId={widget.get("vimeoVideoId")}
        />
      )}
    </div>
  );
}

Scrivito.provideComponent("VimeoVideoWidget", VimeoVideoWidgetComponent);
